
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as ErrorIconComponent } from "./error-icon.svg";

export const ErrorIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <ErrorIconComponent {...props} />;
};
